import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface RetailerFileInventoryFailureProps extends BaseTemplateProps {
  filename: string
  locationCodes: string
}

export const RetailerFileInventoryFailureNotification: TemplateDefinition<RetailerFileInventoryFailureProps> =
  {
    renderParams: (props: RetailerFileInventoryFailureProps) => ({
      messageKey: 'notificationsDomain.templates.retailerFileInventoryFailureNotification',
      values: {
        filename: props.filename,
        locationCodes: props.locationCodes,
      },
    }),
  }
